var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-password",class:[
    {'is-error': _vm.isError },
    {'is-with-description': _vm.description }
  ]},[_c('div',{staticClass:"el-password__container"},[_c('el-input',_vm._b({attrs:{"show-password-icon":_vm.withIcon,"spellcheck":false,"type":"password"},on:{"input":_vm.onInput,"change":_vm.onChange,"blur":_vm.onBlur,"focus":_vm.onFocus,"click":_vm.onClick}},'el-input',_vm.$props,false)),_vm._v(" "),(_vm.hasScore)?_c('div',{staticClass:"el-password__score",class:[
        {'el-password__score--weak': _vm.score === 1},
        {'el-password__score--normal': _vm.score === 2},
        {'el-password__score--strong': _vm.score === 3}
      ]},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el-password__description"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }